import Main from './components/main'
import './App.css';

function App() {
  return (
    <div className="wrapper">
      <div id="main">
      <Main/>
      </div>
    </div>
  );
}

export default App;
